<script lang="ts">
    import { setCurrentZIndexContext } from '$components/ZIndex/Context';
    import { readable, writable, get } from 'svelte/store';
    import { getCurrentZIndexContext } from '$components/ZIndex/Context.js';
    import { match, P } from 'ts-pattern';

    export let zIndex: number | 'current' | 'inc' = 'inc';
    let zIndexStore = writable(zIndex);
    $: $zIndexStore = zIndex;

    const prevZIndexStore = getCurrentZIndexContext();
    const current = readable(
        match($zIndexStore)
            .with('inc', () => $prevZIndexStore + 1)
            .with('current', () => $prevZIndexStore)
            .with(P.number.select(), (z) => z)
            .exhaustive(),
        (set) => {
            let zIndex = get(zIndexStore);
            let prevZIndex = get(prevZIndexStore);

            function sync() {
                set(
                    match(zIndex)
                        .with('inc', () => prevZIndex + 1)
                        .with('current', () => prevZIndex)
                        .with(P.number.select(), (z) => z)
                        .exhaustive(),
                );
            }

            let cleaner = [
                zIndexStore.subscribe((v) => {
                    zIndex = v;
                    sync();
                }),
                prevZIndexStore.subscribe((v) => {
                    prevZIndex = v;
                    sync();
                }),
            ];

            return () => cleaner.forEach((cb) => cb());
        },
    );

    setCurrentZIndexContext(current);

    interface $$Slots {
        default: {
            zIndex: number;
        };
    }
</script>

<slot zIndex={$current} />
